import { create } from 'zustand';

import { useCohortDefinitionStore } from '@verantos-dev/app-state-cohort-definition';
import type { CohortBuilderDefinitionLegacy } from '@verantos-dev/types-cohorts';

// TODO: cleanup with explicit_save ff
const SAVE_TIMEOUT_MS = 8_000;

interface SaveTimeoutNoticeStore {
  isOpen: boolean;
  pendingPayload: CohortBuilderDefinitionLegacy | null;
  /**
   * Legacy socket-autosave path: schedules an 8s backstop. If `isSaving` is
   * still true when the timer fires, the failure pill opens. Used as a stall
   * detector because the legacy round-trip has no real failure signal.
   * TODO: cleanup with research_assistant_gen_3 ff.
   */
  armTimeout: (payload: CohortBuilderDefinitionLegacy) => void;
  /**
   * Gen-3 REST-autosave path: REST gives a real lifecycle (onSuccess / onError),
   * so the autosave caller flips the failure pill open directly on mutation
   * error rather than waiting on a timer. Pass the same payload the caller
   * tried to save so the Retry button can re-fire it.
   */
  openFailure: (payload: CohortBuilderDefinitionLegacy) => void;
  dismiss: () => void;
}

let timerId: ReturnType<typeof setTimeout> | undefined;

export const useSaveTimeoutNoticeStore = create<SaveTimeoutNoticeStore>((set) => ({
  isOpen: false,
  pendingPayload: null,
  armTimeout: (payload) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      timerId = undefined;
      if (useCohortDefinitionStore.getState().profile.isSaving) {
        set({ isOpen: true, pendingPayload: payload });
      }
    }, SAVE_TIMEOUT_MS);
  },
  openFailure: (payload) => {
    clearTimeout(timerId);
    timerId = undefined;
    set({ isOpen: true, pendingPayload: payload });
  },
  dismiss: () => {
    clearTimeout(timerId);
    timerId = undefined;
    set({ isOpen: false, pendingPayload: null });
  },
}));
